const DEALER_TYPES = [
	{ key: 1, value: 'buyer', label: 'Buying', railsValue: 0 },
	{ key: 2, value: 'seller', label: 'Selling', railsValue: 1 },
];

export default DEALER_TYPES;
